export default [
  {
    path: '/warehouses',
    name: 'warehouses',
    component: () => import('@/views/warehouse/Index.vue'),
  },
]
